export const DEFAULT_FILTERS = {
  statuses: [],
  taskName: '',
};

export const STATUS = {
  DONE: 'DONE',
  PENDING: 'PENDING',
  ERROR: 'ERROR',
  RUNNING: 'RUNNING',
  CANCELLED: 'CANCELLED',
};

export const PRIORITY = {
  LOW: 'LOW',
  MEDIUM: 'MEDIUM',
  HIGH: 'HIGH',
  CRITICAL: 'CRITICAL',
};

export const statuses = [
  { name: 'Завершена', value: STATUS.DONE },
  { name: 'В ожидании', value: STATUS.PENDING },
  { name: 'Ошибка', value: STATUS.ERROR },
  { name: 'Выполняется', value: STATUS.RUNNING },
  { name: 'Отменена', value: STATUS.CANCELLED },
];

export const priorities = [
  { name: 'Низкий', value: PRIORITY.LOW },
  { name: 'Средний', value: PRIORITY.MEDIUM },
  { name: 'Высокий', value: PRIORITY.HIGH },
  { name: 'Критический', value: PRIORITY.CRITICAL },
];

export const statusesNames = {
  [STATUS.DONE]: 'Завершена',
  [STATUS.PENDING]: 'В ожидании',
  [STATUS.ERROR]: 'Ошибка',
  [STATUS.RUNNING]: 'Выполняется',
  [STATUS.CANCELLED]: 'Отменена',
};

export const prioritiesNames = {
  [PRIORITY.LOW]: 'Низкий',
  [PRIORITY.MEDIUM]: 'Средний',
  [PRIORITY.HIGH]: 'Высокий',
  [PRIORITY.CRITICAL]: 'Критический',
};
